import { css } from "../../../styled-system/css";

export const styles = {
  root: (inverted?: boolean) =>
    css({
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: ["0", "baseUnit.mobile3"],
      desktop: {
        flexDirection: inverted ? "row-reverse" : "row",
      },
    }),
  displayOnMobile: () =>
    css({
      textAlign: "center",
      desktop: {
        display: "none",
      },
    }),
  displayOnDesktop: () =>
    css({
      display: "none",
      desktop: {
        display: "initial",
      },
    }),
  textWrapper: () =>
    css({
      maxWidth: "528px",
      textAlign: "center",
    }),
};
